





















































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import Service from "@/services/RetensiAlihMediaService";
import {
  STATUS_LABELS,
  KLASIFIKASI_LABELS,
  SignerRole,
  BeritaAcaraJenis,
  Penilaian,
  DocStatus,
  SessionStatus,
  KlasifikasiHasil,
} from "@/types/RetensiAlihMedia";

@Component({
  name: "RetensiAlihMediaDetailPage",
  components: {
    DaftarBerkasTab: () =>
      import("@/components/retensi-alih-media/DaftarBerkasTab.vue"),
  },
})
export default class RetensiAlihMediaDetailPage extends Vue {
  store = RetensiStore;
  tab = 0;

  signerOrder: { role: SignerRole; label: string }[] = [
    { role: "pmik_pelaksana", label: "PMIK Pelaksana" },
    { role: "auditor", label: "Auditor" },
    { role: "karu_rm", label: "Ka. Unit RM" },
    { role: "direktur", label: "Direktur" },
  ];

  get sessionId(): number {
    return Number(this.$route.params.id);
  }

  get session() {
    return this.store.currentSession;
  }

  get isLocked(): boolean {
    return this.store.isLocked;
  }

  get statusLabel(): string {
    return STATUS_LABELS[this.session!.status as SessionStatus] || "—";
  }

  get statusColor(): string {
    const map: Record<SessionStatus, string> = {
      draft: "grey",
      checklist_done: "blue",
      signed_pmik: "indigo",
      signed_auditor: "deep-purple",
      signed_karu_rm: "purple",
      signed_direktur: "teal",
      finalized: "green",
      locked: "green darken-2",
    };
    return map[this.session!.status as SessionStatus] || "grey";
  }

  get klasifikasiLabel(): string {
    const k = this.session?.klasifikasi_hasil;
    return k ? KLASIFIKASI_LABELS[k] : "—";
  }

  get klasifikasiColor(): string {
    return (
      ({
        sangat_baik: "green",
        baik: "blue",
        cukup: "orange",
        kurang: "red",
      } as Record<string, string>)[this.session?.klasifikasi_hasil || ""] ||
      "grey"
    );
  }

  get klasifikasiTextColor(): string {
    return (
      ({
        sangat_baik: "green--text",
        baik: "blue--text",
        cukup: "orange--text",
        kurang: "red--text",
      } as Record<string, string>)[this.session?.klasifikasi_hasil || ""] ||
      "grey--text"
    );
  }

  async mounted() {
    await this.store.fetchSession(this.sessionId);
  }

  async reload() {
    await this.store.fetchSession(this.sessionId);
  }

  rekapForGroup(kelompok: string) {
    return this.session?.rekap_per_section?.[kelompok];
  }

  rekapColor(r: any): string {
    if (!r || r.persen === null) return "grey";
    if (r.persen >= 90) return "green";
    if (r.persen >= 75) return "blue";
    if (r.persen >= 60) return "orange";
    return "red";
  }

  penilaianColor(p: Penilaian): string {
    if (p === "ya") return "green";
    if (p === "tidak") return "red";
    if (p === "na") return "grey";
    return "grey lighten-2";
  }

  docStatusColor(s: DocStatus | undefined): string {
    return (
      ({
        preliminary: "grey",
        final: "green",
        superseded: "orange",
        entered_in_error: "red",
      } as Record<string, string>)[s ?? "preliminary"] || "grey"
    );
  }

  formatDate(iso: string | null | undefined): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("id-ID");
  }

  formatDateTime(iso: string | null | undefined): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("id-ID");
  }

  goBack() {
    this.$router.push({ name: "RetensiAlihMediaDaftar" });
  }

  openLaporanPdf() {
    window.open(Service.laporanPdfUrl(this.sessionId), "_blank");
  }

  openExcel() {
    window.open(Service.excelUrl(this.sessionId), "_blank");
  }

  openBaPdf(jenis: BeritaAcaraJenis) {
    window.open(Service.beritaAcaraPdfUrl(this.sessionId, jenis), "_blank");
  }

}
